<template>
  <div class="kpi-rules">
    <h1 v-if="!editandoPago" style="text-align: center;">Nueva Regla de Gasto</h1>
    <h1 v-else style="text-align: center;">Editar Regla de Gasto</h1>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      layout="vertical"
      finish-button-text="Guardar"
      back-button-text="Atras"
      class="wizard-vertical mb-3 wizard-harber"
      ref="wizardPago"
    >
    <template v-slot:footer="props">
      <div class="wizard-footer-left">
        <b-button
          v-if="props.activeTabIndex > 0"
          :style="props.fillButtonStyle"
          @click="atrasPaso(props)"
          class="wizard-button"
        >
          Atras
        </b-button>
      </div>
      <div class="wizard-footer-right">
        <b-button
          v-if="!props.isLastStep"
          @click="siguientePaso(props)"
          class="wizard-button"
          :style="props.fillButtonStyle"
          id="next-button"
        >
          Continuar
        </b-button>

        <b-button
          v-else
          @click="formSubmitted()"
          class="finish-button"
          style="background-color: #3bab76 !important;
          border-color: #3bab76 !important;"
        >
          Guardar
        </b-button>

        <b-button
          v-if="editandoPago"
          @click="resetWizard()"

          style="background-color: #3b80ab !important;
          border-color: #3b80ab !important;
          margin: 0 auto;
          position: absolute;
          left: 50%;
          "
        >
          Reset
        </b-button>
        
      </div>
    </template>
      <!-- account datails tab -->
      <tab-content title="Tipo">
        <b-row>
          <!--<b-col cols="12" class="mb-2">
            <h5 class="mb-0">Tipo de gasto</h5>
          </b-col>-->
          <b-col md="4">
            <b-card
              :class="{'border-puntual': tipoGasto === 'puntual'}"
              class="mb-2 text-center card-click gasto-puntual"
              @click="tipoGasto = 'puntual'"
              title="Puntual"
            >

              <span class="circle-indicator gasto-puntual"></span>

              <b-card-text style="text-align: center;">
                Un unico pago en una fecha específica que no se va a repetir, solo afectara a un dia.
              </b-card-text>

              <b-form-group v-slot="{ ariaDescribedby }" class="d-flex justify-content-center">
                <b-form-radio v-model="tipoGasto" :aria-describedby="ariaDescribedby" name="some-radios" value="puntual"   :class="`radio-${tipoGasto}`" 
                ></b-form-radio>
              </b-form-group>
            </b-card>
          </b-col>
          <b-col md="4" v-if="false">
            <b-card
              :class="{'border-mensual': tipoGasto === 'mensual'}"
              class="mb-2 text-center card-click gasto-mensual"
              @click="tipoGasto = 'mensual'"
              title="Mensual"
            >

                <span class="circle-indicator gasto-mensual"></span>

                <b-card-text style="text-align: center;">
                  Un gasto que se repite cada mes, se prorrateara el gasto diariamente.
                </b-card-text>

                <b-form-group v-slot="{ ariaDescribedby }" class="d-flex justify-content-center">
                  <b-form-radio v-model="tipoGasto" :aria-describedby="ariaDescribedby" name="some-radios" value="mensual"  :class="`radio-${tipoGasto}`"  ></b-form-radio>
                </b-form-group>
            </b-card>
          </b-col>
          <b-col md="4">
            <b-card
              :class="{'border-anual': tipoGasto === 'anual'}"
              class="mb-2 text-center card-click gasto-anual"
              @click="tipoGasto = 'anual'"
              title="Anual"
            >

              <span class="circle-indicator gasto-anual"></span>
              <b-card-text style="text-align: center;">
                Un unico pago anual en una fecha específica, se prorrateara el gasto diariamente.
              </b-card-text>

              <b-form-group v-slot="{ ariaDescribedby }" class="d-flex justify-content-center">
                <b-form-radio v-model="tipoGasto" :aria-describedby="ariaDescribedby" name="some-radios" value="anual"  :class="`radio-${tipoGasto}`" ></b-form-radio>
              </b-form-group>
              
            </b-card>
          </b-col>
          <b-col md="4">
            <b-card
              :class="{'border-nomina': tipoGasto === 'nomina'}"
              class="mb-2 text-center card-click gasto-nomina"
              @click="tipoGasto = 'nomina'"
              title="Nomina"
            >
              <span class="circle-indicator gasto-nomina"></span>
              <b-card-text style="text-align: center;">
                Pondremos el precio de las nominas correspondientes de un mes. (el precio se prorrateara diariamente al mes siguiente)
              </b-card-text>

              <b-form-group v-slot="{ ariaDescribedby }" class="d-flex justify-content-center">
                <b-form-radio v-model="tipoGasto" :aria-describedby="ariaDescribedby" name="some-radios" value="nomina"  :class="`radio-${tipoGasto}`" ></b-form-radio>
              </b-form-group>
            </b-card>
          </b-col>
          <b-col md="4">
            <b-card
              :class="{'border-impuestos': tipoGasto === 'impuestos'}"
              class="mb-2 text-center card-click gasto-impuestos"
              @click="tipoGasto = 'impuestos'"
              title="Impuestos"
            >
              <span class="circle-indicator gasto-impuestos"></span>
              <b-card-text style="text-align: center;">
                Gasto que se va a prorratear diariamente durante un tramo de tiempo.
              </b-card-text>

              <b-form-group v-slot="{ ariaDescribedby }" class="d-flex justify-content-center">
                <b-form-radio v-model="tipoGasto" :aria-describedby="ariaDescribedby" name="some-radios" value="impuestos"  :class="`radio-${tipoGasto}`" ></b-form-radio>
              </b-form-group>
            </b-card>
          </b-col>
          <b-col md="4">
            <b-card
              :class="{'border-ads': tipoGasto === 'ads'}"
              class="mb-2 text-center card-click gasto-ads"
              @click="tipoGasto = 'ads'"
              title="Ads"
            >
              <span class="circle-indicator gasto-ads"></span>
              <b-card-text style="text-align: center;">
                Gasto que se va a prorratear diariamente durante el mes seleccionado.
              </b-card-text>

              <b-form-group v-slot="{ ariaDescribedby }" class="d-flex justify-content-center">
                <b-form-radio v-model="tipoGasto" :aria-describedby="ariaDescribedby" name="some-radios" value="ads"  :class="`radio-${tipoGasto}`" ></b-form-radio>
              </b-form-group>
            </b-card>
          </b-col>
          <b-col md="4">
            <b-card
              :class="{'border-envios': tipoGasto === 'envios'}"
              class="mb-2 text-center card-click gasto-envios"
              @click="tipoGasto = 'envios'"
              title="Envios"
            >
              <span class="circle-indicator gasto-envios"></span>
              <b-card-text style="text-align: center;">
                Un unico pago en una fecha específica que no se va a repetir, solo afectara a un dia.
              </b-card-text>

              <b-form-group v-slot="{ ariaDescribedby }" class="d-flex justify-content-center">
                <b-form-radio v-model="tipoGasto" :aria-describedby="ariaDescribedby" name="some-radios" value="envios"  :class="`radio-${tipoGasto}`" ></b-form-radio>
              </b-form-group>
            </b-card>
          </b-col>
        </b-row>
      </tab-content>

      <!-- personal info tab -->
      <tab-content title="Información">
        <b-row v-if="tipoGasto !== 'nomina' && tipoGasto !== 'impuestos' && tipoGasto !== 'ads'">
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Información</h5>
            <!--<small class="text-muted">Enter Your Personal Info.</small>-->
          </b-col>
          <b-col md="3">
            <b-form-group label="Nombre*" label-for="v-first-name">
              <b-form-input id="v-first-name" placeholder="" v-model="nombre" />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Descripcion" label-for="v-last-name">
              <b-form-input id="v-last-name" placeholder=""  v-model="descripcion"/>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Empresa*" label-for="v-country">
              <v-select
                id="v-country"
                v-model="empresaSeleccionada"
                :options="empresas"
                label="text"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Categoria*" label-for="v-country">
              <v-select
                id="v-country"
                v-model="categoriaSeleccionada"
                :options="categorias"
                label="text"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Importancia" label-for="v-country">
              <v-select
                id="v-country"
                v-model="importanciaSeleccionada"
                :options="importanciaOpciones"
                label="text"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="tipoGasto === 'nomina'">
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Información {{ tipoGasto }}</h5>
            <!--<small class="text-muted">Enter Your Personal Info.</small>-->
          </b-col>
          <b-col md="4">
            <b-form-group label="Nombre" label-for="v-last-name">
              <b-form-input id="v-last-name" placeholder=""  v-model="nombre"/>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Empresa*" label-for="v-country">
              <v-select
                id="v-country"
                v-model="empresaSeleccionada"
                :options="empresas"
                label="text"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Moneda*" label-for="v-moneda">
              <v-select
                id="v-moneda"
                v-model="monedaSeleccionada"
                :options="monedas"
                label="text"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Precio (Sera automatico)" label-for="v-precio">
              <b-form-input id="v-precio" type="number" step="0.01" placeholder="Ingrese el precio"  v-model="precio" readonly @wheel.prevent/>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Fecha (Sera automatica)" label-for="v-fecha">
              <b-form-input id="v-fecha" type="date" placeholder="Ingrese la fecha"  v-model="fecha"  readonly/>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="tipoGasto === 'impuestos'">
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Información {{ tipoGasto }}</h5>
            <!--<small class="text-muted">Enter Your Personal Info.</small>-->
          </b-col>
          <b-col md="4">
            <b-form-group label="Nombre" label-for="v-last-name">
              <b-form-input id="v-last-name" placeholder=""  v-model="nombre"/>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Empresa*" label-for="v-country">
              <v-select
                id="v-country"
                v-model="empresaSeleccionada"
                :options="empresas"
                label="text"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Moneda*" label-for="v-moneda">
              <v-select
                id="v-moneda"
                v-model="monedaSeleccionada"
                :options="monedas"
                label="text"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Precio (Sera automatico)" label-for="v-precio">
              <b-form-input id="v-precio" type="number" step="0.01" placeholder="Ingrese el precio"  v-model="precio"  readonly @wheel.prevent/>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Fecha (Sera automatica)" label-for="v-fecha">
              <b-form-input id="v-fecha" type="date" placeholder="Ingrese la fecha"  v-model="fecha" readonly/>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Tipo de cobro*" label-for="v-fecha-anual-tipo">
              <b-form-select v-model="tipoAnualCobro" :options="optionsAnualCobroImpuestos" class="mb-2"></b-form-select>              
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="tipoGasto === 'ads'">
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Información {{ tipoGasto }}</h5>
            <!--<small class="text-muted">Enter Your Personal Info.</small>-->
          </b-col>
          <b-col md="4">
            <b-form-group label="Nombre" label-for="v-last-name">
              <b-form-input id="v-last-name" placeholder=""  v-model="nombre"/>
            </b-form-group>
          </b-col>          
          <b-col md="2">
            <b-form-group label="Moneda*" label-for="v-moneda">
              <v-select
                id="v-moneda"
                v-model="monedaSeleccionada"
                :options="monedas"
                label="text"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Precio (Sera automatico)" label-for="v-precio">
              <b-form-input id="v-precio" type="number" step="0.01" placeholder="Ingrese el precio"  v-model="precio" readonly @wheel.prevent/>
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="IVA %" label-for="v-iva">
              <b-form-input id="v-iva" type="number" placeholder="Ingrese el % de IVA"  v-model="iva" @wheel.prevent/>
            </b-form-group>
          </b-col>

          <b-col md="2">
            <b-form-group label="Fecha (Sera automatica)" label-for="v-fecha">
              <b-form-input id="v-fecha" type="date" placeholder="Ingrese la fecha"  v-model="fecha" readonly/>
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>

      <!-- Coste -->
      <tab-content title="Coste">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Coste</h5>
            <small class="text-muted">Introduce toda la informacion del coste del gasto.</small>
          </b-col>
          <b-col md="4">
            <b-form-group label="Moneda*" label-for="v-moneda">
              <v-select
                id="v-moneda"
                v-model="monedaSeleccionada"
                :options="monedas"
                label="text"
              />
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Precio (Sera automatico)" label-for="v-precio">
              <b-form-input id="v-precio" type="number" step="0.01" placeholder="Ingrese el precio"  v-model="precio" readonly @wheel.prevent/>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="IVA %" label-for="v-iva">
              <b-form-input id="v-iva" type="number" placeholder="Ingrese el % de IVA"  v-model="iva" @wheel.prevent/>
            </b-form-group>
          </b-col>

          <b-col md="4" v-if="tipoGasto === 'puntual' || tipoGasto === 'anual'">
            <b-form-group label="Fecha (Sera automatico)" label-for="v-fecha">
              <b-form-input id="v-fecha" type="date" placeholder="Ingrese la fecha"  v-model="fecha" readonly/>
            </b-form-group>
          </b-col>
          <b-col md="2" v-else> </b-col>

          <b-col md="4" v-if="tipoGasto === 'anual'">
            <b-form-group label="Tipo de cobro*" label-for="v-fecha-anual-tipo">
              <b-form-select v-model="tipoAnualCobro" :options="optionsAnualCobro" class="mb-2"></b-form-select>              
            </b-form-group>
          </b-col>

          <b-col md="4" v-if="false">
            <b-form-group label="Fecha de Inicio*" label-for="v-fecha-inicio">
              <b-form-input id="v-fecha-inicio" type="date" placeholder="Ingrese la fecha de inicio"  v-model="fechaInicio"/>
            </b-form-group>
          </b-col>

          <b-col md="4" v-if="false">
            <b-form-group label="Fecha de Fin*" label-for="v-fecha-fin">
              <b-form-input id="v-fecha-fin" type="date" placeholder="Ingrese la fecha de fin"  v-model="fechaFin" />
            </b-form-group>
          </b-col>

          <b-col md="2" v-if="tipoGasto === 'mensual'">
            <b-form-group label="Mes de Inicio*" label-for="v-fecha-mes-inicio">
              <b-form-select v-model="mesInicioSeleccionado" :options="meses" class="mb-2"></b-form-select>              
            </b-form-group>
          </b-col>

          <b-col md="2" v-if="tipoGasto === 'mensual'">
            <b-form-group label="Año de Inicio*" label-for="v-fecha-ano-inicio">
              <b-form-select v-model="anioInicioSeleccionado" :options="anios"></b-form-select>              
            </b-form-group>
          </b-col>

          <b-col md="2" v-if="tipoGasto === 'mensual'">
            <b-form-group label="Mes de Fin (incluido)" label-for="v-fecha-mes-fin">
              <b-form-select v-model="mesFinSeleccionado" :options="meses" class="mb-2"></b-form-select>              
            </b-form-group>
          </b-col>

          <b-col md="2" v-if="tipoGasto === 'mensual'">
            <b-form-group label="Año de Fin (incluido)" label-for="v-fecha-ano-fin">
              <b-form-select v-model="anioFinSeleccionado" :options="anios"></b-form-select>              
            </b-form-group>
          </b-col>
          
        </b-row>
      </tab-content>

      <!-- Requisitos -->
      <tab-content title="Requisitos">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Requisitos</h5>
          </b-col>
          <b-col md="4">
            <b-form-group label="Texto a buscar*" label-for="v-first-name">
              <b-form-input id="v-first-name" placeholder="" v-model="textoRequisito" />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Banco*" label-for="v-country">
              <v-select
                id="v-country"
                v-model="bancoRequisitoSeleccionado"
                :options="banksRquisitos"
                label="text"
              />
            </b-form-group>
          </b-col>
        </b-row>
          
        <b-row>
          <b-col md="2">
            <b-form-group label="Precio mínimo (incluido)" label-for="v-first-name">
              <b-form-input id="v-first-name" placeholder="" v-model="precioMinRequisito" />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Precio máximo (incluido) " label-for="v-first-name">
              <b-form-input id="v-first-name" placeholder="" v-model="precioMaxRequisito" />
            </b-form-group>
          </b-col>          
        </b-row>

        <b-row>
          <b-col md="2">
            <b-form-group label="Día del mes mínimo (incluido)" label-for="dia-min">
              <b-form-select 
                id="dia-min" 
                v-model="diaMinRequisito"
                :options="diasDelMes"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Día del mes máximo (incluido)" label-for="dia-max">
              <b-form-select 
                id="dia-max" 
                v-model="diaMaxRequisito"
                :options="diasDelMes"
              />
            </b-form-group>
          </b-col>
        </b-row>

      </tab-content> 

      <!-- social link -->
      <tab-content title="Resumen">
        <b-row>
            <b-col md="6" class="mx-auto">
              <b-row>
                <b-col md="6">
                  <b-card-text>
                    <strong>Tipo de Gasto:</strong> {{ tipoGasto }}
                  </b-card-text>
                  <b-card-text>
                    <strong>Nombre:</strong> {{ nombre }}
                  </b-card-text>
                  <b-card-text>
                    <strong>Descripción:</strong> {{ descripcion }}
                  </b-card-text>
                  <b-card-text>
                    <strong>Empresa:</strong> {{ empresaSeleccionada.text }}
                  </b-card-text>
                  <b-card-text>
                    <strong>Categoría:</strong> {{ categoriaSeleccionada.text }}
                  </b-card-text>
                  <b-card-text>
                    <strong>Texto a buscar:</strong> {{ textoRequisito }}
                  </b-card-text>
                  <b-card-text>
                    <strong>Banco:</strong> {{ bancoRequisitoSeleccionado.value }}
                  </b-card-text>
                </b-col>
                <b-col md="6">                  
                  <b-card-text>
                    <strong>Moneda:</strong> {{ monedaSeleccionada.text }}
                  </b-card-text>
                  <b-card-text>
                    <strong>Precio:</strong> {{ precio }}
                  </b-card-text>
                  <b-card-text>
                    <strong>IVA:</strong> {{ iva }}%
                  </b-card-text>
                  <b-card-text v-if="tipoGasto === 'puntual' || tipoGasto === 'anual' || tipoGasto === 'impuestos' || tipoGasto === 'ads' || tipoGasto === 'nomina'">
                    <strong>Fecha:</strong> {{ fecha }}
                  </b-card-text>
                  <b-card-text v-if="tipoGasto === 'anual' || tipoGasto === 'impuestos'">
                    <strong>Tipo de Cobro:</strong> {{ tipoAnualCobro }}
                  </b-card-text>
                  <b-card-text v-if="tipoGasto === 'mensual'">
                    <strong>Fecha de Inicio:</strong> {{ mesInicioSeleccionado }}/{{ anioInicioSeleccionado }}
                  </b-card-text>
                  <b-card-text v-if="tipoGasto === 'mensual'">
                    <strong>Fecha de Fin:</strong> {{ mesFinSeleccionado }}/{{ anioFinSeleccionado }}
                  </b-card-text>
                </b-col>
              </b-row>
          </b-col>
        </b-row>
      </tab-content>
    </form-wizard>

    <h1 style="text-align: center; margin-top: 0px;">Listado de reglas</h1>
    <b-card class="wizard-harber">

      <b-row>
        <b-col md="3">
          <b-form-group label="Buscar" label-for="v-texto-buscar">
            <b-form-input id="v-texto-buscar" type="text" placeholder=""  v-model="filtroTexto"/>
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="Tipo" label-for="v-country">
            <v-select
              id="v-country"
              v-model="filtroTipo"
              :options="tipos"
              label="text"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="Empresa" label-for="v-country">
            <v-select
              id="v-country"
              v-model="filtroEmpresa"
              :options="empresas"
              label="text"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Categoria" label-for="v-country">
            <v-select
              id="v-country"
              v-model="filtroCategorias"
              :options="categorias"
              label="text"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group label="Importancia" label-for="v-country">
            <v-select
              id="v-country"
              v-model="filtroImportancia"
              :options="importanciaOpciones"
              label="text"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <div style="overflow-x: auto; max-width: 100%;" class="wizard-harber">
        <b-table
          :items="formartedItems"
          :fields="columnasTable"
          :tbody-tr-class="rowClass"
          class="table table-borderless table-pagos"
          no-border-collapse
          sort-icon-left
          ref="tablePagos"
        >

        <template #cell(_edit)="data">
          <span @click="editPago(data.item)" class="btn-edit">
            <i class="fa-solid fa-pen-to-square"></i>
          </span>
        </template>

          <template #cell(options)="data">
            <span class="btn-delete" @click="deletePago(data.item)">
              <i class="fa-solid fa-trash"></i>
            </span>
          </template>
      
          <template #cell(_tipo)="data">
            <span v-if="data.item.tipoGasto == 'anual'">Anual {{ data.item.tipoCobroAnual }}</span>
            <span v-else>{{ data.item.tipoGasto.charAt(0).toUpperCase() + data.item.tipoGasto.slice(1) }}</span>
          </template>

          <template #cell(_iva)="data">
            <span v-if="data.item.iva.length > 0">{{ data.item.iva }}%</span>
          </template>
        </b-table>
      </div>

    </b-card>
  </div>
</template>
  
<script>
/**/

import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { BRow, BCol, BFormGroup, BFormInput } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import * as XLSX from 'xlsx';
import Papa from "papaparse";
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'

import axios from '@axios'

export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    AppCollapse,
        AppCollapseItem,
  },
  data() {
    return {
      empresaSeleccionada: "",
      empresas: [
        { value: "Harber London", text: "Harber London" },
        { value: "Craft Lab", text: "Craft Lab" },
      ],
      categoriaSeleccionada: "",
      categorias: [
        { value: "Costes de venta", text: "Costes de venta" },
        { value: "Materiales", text: "Materiales" },
        { value: "Envios y devoluciones", text: "Envios y devoluciones" },
        { value: "Compra de productos", text: "Compra de productos" },
        { value: "Marketing", text: "Marketing" },
        { value: "Servicios", text: "Servicios" },
        { value: "Gastos de servicios", text: "Gastos de servicios" },
        { value: "Subscripciones", text: "Subscripciones" },
        { value: "Nominas", text: "Nominas" },
        { value: "Impuestos", text: "Impuestos" },
        { value: "Alquileres", text: "Alquileres" },
        { value: "Almacenamiento", text: "Almacenamiento" },
        { value: "Seguros", text: "Seguros" },
        { value: "Reparaciones", text: "Reparaciones" },
        { value: "Equipos Informaticos", text: "Equipos Informáticos" },
        { value: "Maquinaria", text: "Maquinaria" },
        { value: "Gastos de Oficina", text: "Gastos de Oficina" },
        { value: "Gastos de Fabrica", text: "Gastos de Fábrica" },
        { value: "Prestamos", text: "Prestamos" }
      ],
      monedaSeleccionada: "",
      monedas: [
        { value: "Euro", text: "Euro" },
        { value: "Dolar", text: "Dolar" },
        { value: "Libra", text: "Libra" },
      ],
      importanciaSeleccionada: "",
      importanciaOpciones: [
        { value: "Obligatorios", text: "Obligatorios" },
        { value: "Indispensables", text: "Indispensables" },
        { value: "Necesarios", text: "Necesarios" },
        { value: "Dispensables", text: "Dispensables" },
      ],
      tiposEdit: [
        { value: "puntual", text: "Puntual" },
        { value: "mensual", text: "Mensual" },
        { value: "anual", text: "Anual" },
        { value: "impuestos", text: "Impuestos" },
        { value: "nomina", text: "Nomina" },
        { value: "ads", text: "Ads" },
        { value: "envios", text: "Envios" },
      ],
      filtroImportancia: "",
      filtroCategorias: "",
      filtroTexto: "",
      filtroEmpresa: "",
      filtroTipo: "",
      tipos: [
        { value: "puntual", text: "Puntual" },
        { value: "mensual", text: "Mensual" },
        { value: "anual", text: "Anual" },
        { value: "impuestos", text: "Impuestos" },
        { value: "nomina", text: "Nomina" },
        { value: "ads", text: "Ads" },
        { value: "envios", text: "Envios" },
      ],
      diasDelMes: Array.from({ length: 31 }, (_, i) => ({ value: i + 1, text: (i + 1).toString() })),
      tipoGasto: "",
      nombre: "",
      descripcion: "",
      precio: "",
      iva: "",
      fecha: "",
      fechaInicio: "",
      fechaFin: "",
      tipoAnualCobro: "",
      optionsAnualCobro: [
        { value: 'natural', text: 'Año Natural (1 Enero / 31 Diciembre)' },
        { value: 'retrospectivo anterior', text: 'Año Retrospectivo Anterior (15 Febrero 2025 / 15 Febrero 2024)' },
        { value: 'retrospectivo siguiente', text: 'Año Retrospectivo Siguiente (15 Febrero 2025 / 15 Febrero 2026)' },
      ],
      optionsAnualCobroImpuestos: [
        { value: 'mensual', text: 'Mensual (se proratea en el mes seleccionado)' },
        { value: 'trimestral', text: 'Trimestral (se proratea en 3 meses a partir del seleccionado)' },
        { value: 'semestral', text: 'Semestral (se proratea en 6 meses a partir del seleccionado)' },
        { value: 'retrospectivo anterior', text: 'Año Retrospectivo Anterior (15 Febrero 2025 / 15 Febrero 2024)' },
        { value: 'retrospectivo siguiente', text: 'Año Retrospectivo Siguiente (15 Febrero 2025 / 15 Febrero 2026)' },
      ],
      mesInicioSeleccionado: "",
      anioInicioSeleccionado: "",
      mesFinSeleccionado: "",
      anioFinSeleccionado: "",
      mesFinSeleccionadoEdit: "",
      anioFinSeleccionadoEdit: "",
      titleFechaFin: "Fecha fin",
      idEditFechaFin: 0,
      meses: [
        { value: '01', text: 'Enero' },
        { value: '02', text: 'Febrero' },
        { value: '03', text: 'Marzo' },
        { value: '04', text: 'Abril' },
        { value: '05', text: 'Mayo' },
        { value: '06', text: 'Junio' },
        { value: '07', text: 'Julio' },
        { value: '08', text: 'Agosto' },
        { value: '09', text: 'Septiembre' },
        { value: '10', text: 'Octubre' },
        { value: '11', text: 'Noviembre' },
        { value: '12', text: 'Diciembre' },
      ],
      anios: Array.from({ length: 16 }, (_, i) => {
        const year = new Date().getFullYear() - 5 + i;
        return { value: year, text: year };
      }),
      allRules: [],
      rulesBusqueda: "",
      columnasTable: [
        {
          key: "_edit",
          label: "",
          sortable: false,
          thStyle: { width: "1%" },
        },
        {
          key: "nombre",
          label: "nombre",
          sortable: true,
        },
        {
          key: "descripcion",
          label: "Descripcion",
          sortable: true,
        },
        {
          key: "textoRequisito",
          label: "Texto",
          sortable: true,
        },
        {
          key: "bancoRequisito",
          label: "Banco",
          sortable: true,
        },
        {
          key: "empresa",
          label: "Empresa",
          sortable: true,
        },
        {
          key: "categoria",
          label: "Categoria",
          sortable: true,
        },
        {
          key: "_tipo",
          label: "Tipo",
          sortable: true,
        },
        {
          key: "moneda",
          label: "Moneda",
          sortable: true,
        },
        {
          key: "_iva",
          label: "IVA",
          sortable: true,
        },
        {
          key: "importancia",
          label: "Importancia",
          sortable: true,
        },
        {
          key: "options",
          label: "",
          sortable: false,
          thStyle: { width: "1%" },
        },

      ],
      fechaActual: "",
      titleEditarGasto: "",
      //Edit
      nombreEdit: "",
      descripcionEdit: "",
      empresaSeleccionadaEdit: "",
      categoriaSeleccionadaEdit: "",
      monedaSeleccionadaEdit: "",
      importanciaSeleccionadaEdit: "",
      tiopoGastoSeleccionadoEdit: "",
      precioEdit: "",
      ivaEdit: "",
      fechaEdit: "",
      fechaInicioEdit: "",
      fechaFinEdit: "",
      tipoAnualCobroEdit: "",
      tipoGastoEdit: "",
      mesInicioSeleccionadoEdit: "",
      anioInicioSeleccionadoEdit: "",
      mesFinSeleccionadoEdit: "",
      anioFinSeleccionadoEdit: "",
      idEdit: 0,
      banks: [ 
                {   
                    value: "Ibercaja", text: "Ibercaja", typeFile: 'xls', empresa: 'Craft Lab',
                    cFecha: 1, cDescripcion: 4, cConcepto: 3, cPrecio: 6, divisa: 'EUR'
                },
                {   
                    value: "Revolut", text: "Revolut", typeFile: 'csv', empresa: 'Harber London',
                    cFecha: 0, cDescripcion: 7, cConcepto: 8, cPrecio: 17, divisa: 'GBP' 
                },
                {   
                    value: "HSBC Diario", text: "HSBC Diario", typeFile: 'csv', empresa: 'Harber London',
                    cFecha: 0, cDescripcion: 2, cConcepto: 1, cPrecio: 3, divisa: 'GBP' 
                },
                /*{   
                    value: "HSBC", text: "HSBC Mensual", typeFile: 'csv', empresa: 'Harber London',
                    cFecha: 0, cDescripcion: 2, cConcepto: 1, cPrecio: 3, cPrecioIn: 4, divisa: 'GBP' 
                },*/
                {   
                    value: "Sabadell", text: "Sabadell", typeFile: 'xls', empresa: 'Craft Lab',
                    cFecha: 0, cDescripcion: 1, cConcepto: 5, cPrecio: 3, divisa: 'EUR' 
                },
                {   
                    value: "Sabadell Tarjetas", text: "Sabadell Tarjetas", typeFile: 'xls', empresa: 'Craft Lab',
                    cFecha: 0, cDescripcion: 1, cConcepto: 2, cPrecio: 4, divisa: 'EUR' 
                },
                {   
                    value: "Sabadell Envios", text: "Sabadell Envios", typeFile: 'xls', empresa: 'Craft Lab',
                    cFecha: 0, cDescripcion: 1, cConcepto: 5, cPrecio: 3, divisa: 'EUR' 
                },
                {   
                    value: "Paypal", text: "Paypal", typeFile: '', empresa: 'Harber London',
                    cFecha: 0, cDescripcion: 0, cConcepto: 0, cPrecio: 0, divisa: 'GBP' 
                },
      ],
      data: [],     
      textoRequisito:'',
      precioMinRequisito:'',
      precioMaxRequisito:'',
      diaMinRequisito:'',
      diaMaxRequisito:'',
      bancoRequisitoSeleccionado: { value: "Todos", text: "Todos" },
      banksRquisitos: [ 
                {   
                    value: "Todos", text: "Todos" 
                },
                {   
                    value: "Ibercaja", text: "Ibercaja"
                },
                {   
                    value: "Revolut", text: "Revolut"
                },
                {   
                    value: "HSBC Diario", text: "HSBC Diario"
                },
                {   
                    value: "Sabadell", text: "Sabadell"
                },
                {   
                    value: "Sabadell Tarjetas", text: "Sabadell Tarjetas"
                },
                {   
                    value: "Sabadell Envios", text: "Sabadell Envios"
                },
                {   
                    value: "Paypal", text: "Paypal"
                },
      ],
      editandoPago: false

    };
  },
  computed: {
    formartedItems () {
      if (!this.rulesBusqueda) return []
      return this.rulesBusqueda.map(item => {
        item._customClass = this.getCustomClass(item)
        return item
      })
    },
  },
  methods: {    
    getVariant (item) {

        /*if(item.finalizado)
          return 'secondary';
        else */if(item.tipoGasto == "puntual")
          return 'success';
        else if(item.tipoGasto == "mensual")
          return 'warning';
        else if(item.tipoGasto == "anual")
          return 'primary';
        else if(item.tipoGasto == "nomina")
          return 'secondary';
        else if(item.tipoGasto == "impuestos")
          return 'danger';
        else if(item.tipoGasto == "ads")
          return 'info';
        else if(item.tipoGasto == "envios")
          return 'dark';
    },
    getCustomClass(item) {

      if (item.fechaFin) {
        const fechaFin = new Date(item.fechaFin);
        const hoy = new Date();

        // Si la fecha actual es mayor que fechaFin, consideramos finalizado
        if (hoy > fechaFin) {
          return 'gasto-finalizado';
        }
      }
      
      switch (item.tipoGasto) {
        case "puntual":
          return 'gasto-puntual'
        case "mensual":
          return 'gasto-mensual'
        case "anual":
          return 'gasto-anual'
        case "nomina":
          return 'gasto-nomina'
        case "impuestos":
          return 'gasto-impuestos'
        case "ads":
          return 'gasto-ads'
        case "envios":
          return 'gasto-envios'
        default:
          return ''
          
      }
    
    },
    rowClass(item) {
      if (!item) return ''

      if (item.fechaFin) {
        const fechaFin = new Date(item.fechaFin);
        const hoy = new Date();

        if (hoy > fechaFin) {
          return 'gasto-finalizado';
        }
      }

      
      switch (item.tipoGasto) {
        case "puntual":
          return 'gasto-puntual'
        case "mensual":
          return 'gasto-mensual'
        case "anual":
          return 'gasto-anual'
        case "nomina":
          return 'gasto-nomina'
        case "impuestos":
          return 'gasto-impuestos'
        case "ads":
          return 'gasto-ads'
        case "envios":
          return 'gasto-envios'
        default:
          return ''
      }
    },
    getRadioColor(tipo) {
      //console.log(tipo);
      switch(tipo) {
        case 'puntual': return '#28a745';    // verde
        case 'mensual': return '#ffc107';    // amarillo
        case 'anual': return '#007bff';      // azul
        case 'nomina': return '#ff66cc';     // rosa (tu nuevo color)
        case 'impuestos': return '#dc3545';  // rojo
        case 'ads': return '#17a2b8';        // cyan
        case 'envios': return '#343a40';     // gris oscuro
        default: return '#000000';            // negro por defecto
      }
    },
    loadItems(){

      axios.post("/uso", {seccion:"kpi-gastos-rules"});

      this.fechaActual = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

      Promise.all([
        axios.get("/kpi/rules"),
      ]).then(responses => {
        const [rulesResponse] = responses;

        this.allRules = rulesResponse.data.reverse();
        this.rulesBusqueda = rulesResponse.data;

        this.allRules.sort((a, b) => {
          return b.id - a.id;
        });

        this.cargarFiltro();

      });
    },
    formSubmitted() {

      let fechaInicio = "";
      let fechaFin = "";

      let tipoCobroAnual = "";

      if(this.tipoGasto === 'mensual'){
        fechaInicio = this.anioInicioSeleccionado + "-" + this.mesInicioSeleccionado + "-01";

        if(this.anioFinSeleccionado != "" && this.mesFinSeleccionado != "" )
        {
          const year = this.anioFinSeleccionado;
          const month = this.mesFinSeleccionado; // Asegúrate de que es 1-12

          // Obtener el último día del mes seleccionado
          const lastDay = new Date(year, month, 0).getDate();

          // Formatear la fecha correctamente
          fechaFin = `${year}-${String(month).padStart(2, "0")}-${lastDay}`;
          //fechaFin = this.anioFinSeleccionado + "-" + this.mesFinSeleccionado + "-01";
        }
      }
      else if ( this.tipoGasto === 'anual' || this.tipoGasto === 'impuestos'){

        tipoCobroAnual = this.tipoAnualCobro;
      }

      let data = {
        nombre: this.nombre,
        descripcion: this.descripcion,
        empresa: this.empresaSeleccionada.value,
        categoria: this.categoriaSeleccionada.value,
        moneda: this.monedaSeleccionada.value,
        precio: this.precio,
        iva: this.iva,
        fecha: this.fecha,
        fechaInicio: fechaInicio,
        fechaFin: fechaFin,
        tipoGasto: this.tipoGasto,
        tipoCobroAnual: tipoCobroAnual,
        importancia: this.importanciaSeleccionada.value,
        textoRequisito: this.textoRequisito,
        bancoRequisito: this.bancoRequisitoSeleccionado.value,
        precioMinRequisito: this.precioMinRequisito,
        precioMaxRequisito: this.precioMaxRequisito,
        diaMinRequisito: this.diaMinRequisito,
        diaMaxRequisito: this.diaMaxRequisito,
      };

      if(data.diaMinRequisito > data.diaMaxRequisito && data.diaMaxRequisito != '' && data.diaMinRequisito != '')
      {
        let auxDia = data.diaMinRequisito;
        data.diaMinRequisito = data.diaMaxRequisito;
        data.diaMaxRequisito = auxDia;
      }


      const method = this.editandoPago ? 'put' : 'post';
      const url = "/kpi/rules";

      if(this.editandoPago)
        data.id = this.idEdit;

      axios[method](url, { data })
        .then(response => response.data)
        .then(res => {
          data.id = res.id;

          //this.allRules.push(data);

          this.loadItems();

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Regla guardada correctamente",
              icon: "EditIcon",
              variant: "success",
            },
          });

          this.resetWizard();
        });

     
    },
    resetWizard(){
      this.nombre = "";
      this.descripcion = "";
      this.empresaSeleccionada = "";
      this.categoriaSeleccionada = "";
      this.monedaSeleccionada = "";
      this.precio = "";
      this.iva = "";
      this.fecha = "";
      this.fechaInicio = "";
      this.fechaFin = "";
      this.tipoGasto = "";
      this.tipoCobroAnual = "";
      this.importanciaSeleccionada = "";

      this.anioInicioSeleccionado = "";
      this.mesInicioSeleccionado = "";
      this.anioFinSeleccionado = "";
      this.mesFinSeleccionado = "";

      this.diaMinRequisito = '';
      this.diaMaxRequisito = '';
      this.precioMinRequisito = '';
      this.precioMaxRequisito = '';

      this.movimientoSeleccionado = {descripcion: '',
        concepto: '',
        id: 0};

      this.textoRequisito = '';
      this.bancoRequisitoSeleccionado = { value: "Todos", text: "Todos" };

      this.editandoPago = false;
      this.idEdit = 0;

      this.$refs.wizardPago.reset();
    },
    atrasPaso(props){

      if(props.activeTabIndex == 3 && (this.tipoGasto == "nomina" || this.tipoGasto == "impuestos" || this.tipoGasto == "ads"))
      {
        props.prevTab();
        props.prevTab();
      }
      else
        props.prevTab();

    },
    siguientePaso(props){

      function toastShow(title, self){
        self.$toast({
            component: ToastificationContent,
            props: {
              title: title,
              icon: "EditIcon",
              variant: "danger",
            },
          });
      }

      //Paso 1
      if(props.activeTabIndex == 0){
        if(this.tipoGasto != ""){
          props.nextTab();
        }
        else{
          toastShow("Selecciona el tipo de gasto", this);         
        }
      }
     
      //Paso 2
      if (props.activeTabIndex == 1 && this.tipoGasto != "nomina" && this.tipoGasto != "ads" && this.tipoGasto != "impuestos"){
        let continuar = true;
        if(this.nombre == "")
        {
          continuar = false;
          toastShow("Rellena el nombre", this);
        }

        if(this.empresaSeleccionada == "")
        {
          continuar = false;
          toastShow("Rellena la empresa", this);
        }

        if(this.categoriaSeleccionada == "")
        {
          continuar = false;
          toastShow("Rellena la categoria", this);
        }

        if(continuar)
          props.nextTab();
      }

      //Paso 2 Nomina
      if (props.activeTabIndex == 1 && this.tipoGasto == "nomina"){
        let continuar = true;
        /*if(this.precio == "")
        {
          continuar = false;
          toastShow("Rellena el precio", this);
        }

        if(this.fecha == "")
        {
          continuar = false;
          toastShow("Rellena la fecha", this);
        }*/

        if(continuar)
        {
          this.descripcion = "Nomina";
          this.categoriaSeleccionada = this.categorias[8];
          this.importanciaSeleccionada = this.importanciaOpciones[0];

          props.nextTab();
          props.nextTab();
        }
      }

      //Paso 2 Impuestos
      if (props.activeTabIndex == 1 && this.tipoGasto == "impuestos"){
        let continuar = true;
        /*if(this.precio == "")
        {
          continuar = false;
          toastShow("Rellena el precio", this);
        }

        if(this.fecha == "")
        {
          continuar = false;
          toastShow("Rellena la fecha", this);
        }*/

        if(this.empresaSeleccionada == "")
        {
          continuar = false;
          toastShow("Rellena la empresa", this);
        }

        if(this.tipoAnualCobro == "")
        {
          continuar = false;
          toastShow("Rellena el tipo de cobro", this);
        }

        if(this.monedaSeleccionada == "")
        {
          continuar = false;
          toastShow("Rellena la moneda", this);
        }

        if(continuar)
        {
          this.descripcion = "Impuestos";
          this.categoriaSeleccionada = this.categorias[9];
          this.importanciaSeleccionada = this.importanciaOpciones[0];

          props.nextTab();
          props.nextTab();
        }
      }

      //Paso 2 ads
      if (props.activeTabIndex == 1 && this.tipoGasto == "ads"){
        let continuar = true;
        /*if(this.precio == "")
        {
          continuar = false;
          toastShow("Rellena el precio", this);
        }

        if(this.fecha == "")
        {
          continuar = false;
          toastShow("Rellena la fecha", this);
        }*/

        if(this.monedaSeleccionada == "")
        {
          continuar = false;
          toastShow("Rellena la moneda", this);
        }



        if(continuar)
        {
          this.descripcion = "Ads";
          this.categoriaSeleccionada = this.categorias[4];
          this.importanciaSeleccionada = this.importanciaOpciones[2];
          this.empresaSeleccionada = this.empresas[0];

          props.nextTab();
          props.nextTab();
        }
      }

      //Paso 3
      if (props.activeTabIndex == 2){
        let continuar = true;

        if(this.monedaSeleccionada == "")
        {
          continuar = false;
          toastShow("Rellena la moneda", this);
        }

        /*if(this.precio == "")
        {
          continuar = false;
          toastShow("Rellena el precio", this);
        }*/

        /*if(this.fecha == "" && (this.tipoGasto === 'puntual' || this.tipoGasto === 'anual'))
        {
          continuar = false;
          toastShow("Rellena la fecha", this);
        }*/

        if(this.tipoAnualCobro == "" && this.tipoGasto === 'anual')
        {
          continuar = false;
          toastShow("Rellena el tipo de cobro anual", this);
        }

        if(this.mesInicioSeleccionado == "" && this.tipoGasto === 'mensual')
        {
          continuar = false;
          toastShow("Rellena el mes de inicio", this);
        }

        if(this.anioInicioSeleccionado == "" && this.tipoGasto === 'mensual')
        {
          continuar = false;
          toastShow("Rellena el año de inicio", this);
        }

        if(continuar)
          props.nextTab();
      }

      //Paso 4
      if (props.activeTabIndex == 3){
        let continuar = true;

        if(this.textoRequisito == "")
        {
          continuar = false;
          toastShow("Rellena el texto a buscar", this);
        }     

        if(this.bancoRequisitoSeleccionado.value == "" )
        {
          continuar = false;
          toastShow("Selecciona el banco", this);
        }

        if(continuar)
          props.nextTab();
      }

    },
    deletePago(item)
    {
      this.$swal({
          title: 'Estas seguro que quieres la regla: ' + item.nombre,
          icon: 'error',
          showCancelButton: true,
          //html: `<input type="text" id="motivo" class="swal2-input" placeholder="Motivo">`,
          confirmButtonText: 'Si, borrar',
          cancelButtonText: 'No',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {

          if(result.isConfirmed)
          {

            axios
            .delete("/kpi/rules/"+item.id)
            .then(response => {
              return response.data;
            })
            .then(res => {

              this.allRules = this.allRules.filter(pago => pago.id !== item.id);
              this.rulesBusqueda = this.rulesBusqueda.filter(pago => pago.id !== item.id);
              
            });


          }

        })

    },
    editPago(item){ //Todo

      this.idEdit = item.id;
      this.editandoPago = true;

      this.nombre = item.nombre
      this.descripcion = item.descripcion
      this.precio = item.precio
      this.iva = item.iva
      this.fecha = item.fecha
      this.tipoGasto = item.tipoGasto
      this.textoRequisito = item.textoRequisito
      this.bancoRequisitoSeleccionado = item.bancoRequisito
      this.precioMinRequisito = item.precioMinRequisito
      this.precioMaxRequisito = item.precioMaxRequisito
      this.diaMinRequisito = item.diaMinRequisito
      this.diaMaxRequisito = item.diaMaxRequisito

      this.importanciaSeleccionada = { value: item.importancia, text: item.importancia }
      this.empresaSeleccionada = { value: item.empresa, text: item.empresa }
      this.categoriaSeleccionada = { value: item.categoria, text: item.categoria }
      this.monedaSeleccionada = { value: item.moneda, text: item.moneda }

      this.$refs.wizardPago.nextTab();
      this.$refs.wizardPago.nextTab();
      this.$refs.wizardPago.nextTab();
      this.$refs.wizardPago.nextTab();
      this.$refs.wizardPago.nextTab();
      
      window.scrollTo(0, 0);


      //props.nextTab();

    },
    editarFechaPagado(item){
      this.titleFechaFin = "Fecha fin de " + item.nombre;
      this.idEditFechaFin = item.id;
      this.$bvModal.show('modal-fecha-fin');
    },
    buscarFiltro(){
      this.rulesBusqueda = [];

      this.rulesBusqueda = this.allRules.filter(pago => {
        const matchesTexto = pago.nombre.toLowerCase().includes(this.filtroTexto.toLowerCase()) || 
                             pago.descripcion.toLowerCase().includes(this.filtroTexto.toLowerCase());
        const matchesTipo = this.filtroTipo ? pago.tipoGasto === this.filtroTipo.value : true;
        const matchesEmpresa = this.filtroEmpresa ? pago.empresa === this.filtroEmpresa.value : true;
        const matchesCategoria = this.filtroCategorias ? pago.categoria === this.filtroCategorias.value : true;
        const matchesImportancia = this.filtroImportancia ? pago.importancia === this.filtroImportancia.value : true;

        return matchesTexto && matchesTipo && matchesEmpresa && matchesCategoria && matchesImportancia;
      });

    },
    guardarFiltro(){

      let datos = {
        filtroTexto: this.filtroTexto,
        filtroTipo: this.filtroTipo,
        filtroEmpresa: this.filtroEmpresa,
        filtroCategorias: this.filtroCategorias,
        filtroImportancia: this.filtroImportancia
      }

      const date = new Date();
      let hours = 12;
      date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = 'rules' + "=" + JSON.stringify(datos) + ";" + expires + ";path=/";

    },
    cargarFiltro(){

      let datos = null;

      const nameEQ = 'rules' + "=";
      const cookiesArray = document.cookie.split(';');
      for(let i = 0; i < cookiesArray.length; i++) {
          let cookie = cookiesArray[i];
          while (cookie.charAt(0) == ' ') cookie = cookie.substring(1, cookie.length);
          if (cookie.indexOf(nameEQ) == 0) {
            datos =  JSON.parse(cookie.substring(nameEQ.length, cookie.length));
          }
      }

      if(datos != null)
      {
        this.filtroTexto = datos.filtroTexto;
        this.filtroTipo = datos.filtroTipo;
        this.filtroEmpresa = datos.filtroEmpresa;
        this.filtroCategorias = datos.filtroCategorias;
        this.filtroImportancia = datos.filtroImportancia;
      }

    },
  },
  mounted() {    
      this.cargarFiltro();
      this.loadItems();
  },
  watch: {
    filtroTexto(){
      this.buscarFiltro();
      this.guardarFiltro();
    },
    filtroTipo(){
      this.buscarFiltro();
      this.guardarFiltro();
    },
    filtroEmpresa(){
      this.buscarFiltro();
      this.guardarFiltro();
    },
    filtroCategorias(){
      this.buscarFiltro();
      this.guardarFiltro();
    },
    filtroImportancia(){
      this.buscarFiltro();
      this.guardarFiltro();
    },
    /*fecha(){
      console.log(this.fecha);
    }*/
  }
};
</script>

<style lang="scss">
    @import "@core/scss/vue/libs/vue-wizard.scss";
    @import "@core/scss/vue/libs/vue-select.scss";

    .card-click {
      cursor: pointer;
    }

    .finish-button{
      background-color: #3bab76 !important;
      border-color: #3bab76 !important;
      color: white !important;
    }

    .btn-delete{
      color: #ee8080;
    }

    .btn-delete:hover{
      cursor: pointer;
    }

    .btn-edit-pago:hover{
      cursor: pointer;
    }

    .btn-edit-pago{
      color: green;
    }

    .table-pagos td{
      color: black;
    }

    .btn-no-contabilizado{
        color: red;
    }
    .btn-no-contabilizado:hover{
        cursor: pointer;
    }

    .btn-contabilizado{
        color: green;
    }
    .btn-contabilizado:hover{
        cursor: pointer;
    }

    .modal-movimientos{
      min-height: 800px;
    }

    .gasto-puntual { background-color: #c3efd7 !important; color: #155724 !important; border: 4px solid #c3efd7;}
    .gasto-anual { background-color: #d8d4fb !important; color: #004085 !important; border: 4px solid #d8d4fb; }
    .gasto-impuestos { background-color: #f9cfcf !important; color: #721c24 !important; border: 4px solid #f9cfcf; }
    .gasto-mensual { background-color: #ffe4ca !important; color: #856404 !important; border: 4px solid #ffe4ca; }
    .gasto-nomina { background-color: #ffccff !important; color: #660066 !important; border: 4px solid #ffccff;}
    .gasto-ads { background-color: #b8f2f9 !important; color: #0c5460 !important;  border: 4px solid #b8f2f9;}
    .gasto-envios { background-color: #e4edac !important; color: #1b1e21 !important; border: 4px solid #e4edac; }
    .gasto-finalizado { background-color: #dcdddf !important; color: #155724 !important;}

    .border-puntual{border: 4px solid #08bc59;}
    .border-anual{ border: 4px solid #877afd;}
    .border-impuestos{ border: 4px solid #f57f7f;}
    .border-mensual{border: 4px solid #ffa653;}
    .border-nomina{border: 4px solid #fc6bfc;}
    .border-ads{border: 4px solid #03b5c8;}
    .border-envios{border: 4px solid #93a900;}

    .radio-puntual .custom-control-input:checked ~ .custom-control-label::before { border-color: #08bc59; background-color: #08bc59;}
    .radio-anual .custom-control-input:checked ~ .custom-control-label::before { border-color: #877afd; background-color: #877afd;}
    .radio-impuestos .custom-control-input:checked ~ .custom-control-label::before { border-color: #f57f7f; background-color: #f57f7f;}
    .radio-mensual .custom-control-input:checked ~ .custom-control-label::before { border-color: #ffa653; background-color: #ffa653;}
    .radio-nomina .custom-control-input:checked ~ .custom-control-label::before { border-color: #fc6bfc; background-color: #fc6bfc;}
    .radio-ads .custom-control-input:checked ~ .custom-control-label::before { border-color: #03b5c8; background-color: #03b5c8;}
    .radio-envios .custom-control-input:checked ~ .custom-control-label::before { border-color: #93a900; background-color: #93a900;}


    .circle-indicator {
      display: inline-block;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      margin-left: 8px;
      vertical-align: middle;

      position: absolute;
      top: 25px;
      right: 30px;
    }


    .wizard-harber{
      box-shadow: none;
      border: 1px solid lightgray
    }

    .btn-edit:hover{
      cursor: pointer;
    }

        

    
</style>


<style lang="scss">
/* ═══ Modo oscuro ═══ */
.dark-layout .kpi-rules {
  // Tarjetas y filas por tipo de gasto: superficie oscura con borde/tinte del color de acento
  @each $tipo, $color in (puntual: #08bc59, anual: #877afd, impuestos: #f57f7f, mensual: #ffa653, nomina: #fc6bfc, ads: #03b5c8, envios: #93a900) {
    .card-click.gasto-#{$tipo} {
      background-color: #1f1f1f !important;
      color: #d0d2d6 !important;
      border-color: rgba($color, 0.3);

      .card-title { color: #e4e6eb !important; }

      &.border-#{$tipo} {
        background-color: rgba($color, 0.08) !important;
        border-color: $color;
      }
    }

    .circle-indicator.gasto-#{$tipo} {
      background-color: $color !important;
      border-color: transparent !important;
    }

    .table-pagos tr.gasto-#{$tipo} {
      background-color: rgba($color, 0.08) !important;
      color: #d0d2d6 !important;
    }
  }

  .table-pagos tr.gasto-finalizado {
    background-color: #242424 !important;
    color: #8e9099 !important;
  }

  .table-pagos td { color: #d0d2d6 !important; }

  .wizard-harber { border-color: #2c2c2c; }
}
</style>
